package models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("User")
data class User(
    val userName: String,
    val email: String,
    val avatar: String? = null,
)
